enum StateForm {
  Draft = 0,
  Published = 1,
  Archived = 2,
}

export interface FormDTO {
  id: number;
  title?: string;
  isAnonymous: boolean;
  createdBy?: SelectItem;
  createdDate?: Date;
  state: StateForm;
  isArchived: boolean;
  statePublished?: string;
  iconPath?: string;
  isPrimary: boolean;
  numberEntries: number;
  numberEntriesInProgresse: number;
}

export interface FetchFilter {
  searchValue?: string;
  departement?: string;
  area?: string;
  workTime?: string;
  site?: string;
  society?: string;
  service?: string;
  type?: string;
  fonction?: string;
  min?: Date;
  max?: Date;
  offreId?: number;
  dateMin?: string;
  dateMax?: string;
  date_created_max?: string;
  date_created_min?: string;
  range_min?: string;
  range_max?: string;
  range_min_profil?: string;
  range_max_profil?: string;
  status?: string;
  contrat?: string;
  typeConge?: string;
  typeHardware?: string;
  typeSoftware?: string;
  dateFormat?: string;
  lisenceType?: string;
  typeIntervention?: string;
  priority?: string;
  natureIntervention?: string;
  ids?: string[];
  idsNotSelected?: string[];
  dateFinDabonnementMin?: string;
  dateFinDabonnementMax?: string;
  country?: string;
  language?: string;
  statutArchive?: string;
  dataSourceId?: string;
  collaborateur?: string;
  year?: string;
  filterType?: string;
  maxClosureDate?: string;
  minClosureDate?: string;
  tag?: string;
  events?: string;
}

export interface FormList {
  asinedUsers?: number;
  taotalUsers?: number;
  idSource?: number;
  userId?: string;
  lenght: number;
  currentPage: number;
  pageCount: number;
  total: number;
  inProgress: boolean;
  profil: boolean;
  visible: boolean;
  searchValue?: string;
  list?: FormDTO[];
  navigation?: Record<string, string>;
  filter: FetchFilter;
  status?: string;
}

export interface FormAdmin {
  formId: number;
  users: object;
  adminsId: string[];
  adminsList: SelectItem[];
}

export interface FormsResponse {
  forms: FormDTO[];
  countSecondaryForms: number;
}

export interface SecondaryFilter {
  searchValue: string | null;
  lenght: number;
  currentList: number;
  id: number;
  roleName: string | null;
  userid: string | null;
  roleId: string | null;
  ids: string[];
  assigend: boolean;
  selectAll: boolean;
  isGroup: boolean;
  isApprovalEvpLevel: boolean;
}
